import React from 'react';
import { Card } from 'react-bootstrap';

const wikiVideos = [
	{
		id: 'N2LPyZpwmpU',
		title: 'Video introduttivo',
	},
];

const WikiPage = () => {
	return (
		<div className="row">
			{wikiVideos.map((video) => (
				<div className="col-xl-8 col-lg-10" key={video.id}>
					<Card>
						<Card.Header>
							<Card.Title>{video.title}</Card.Title>
						</Card.Header>
						<Card.Body>
							<div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
								<iframe
									src={`https://www.youtube.com/embed/${video.id}`}
									title={video.title}
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
									style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
								/>
							</div>
						</Card.Body>
					</Card>
				</div>
			))}
		</div>
	);
};

export default WikiPage;
